var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:[{border: _vm.border}, _vm.size],style:({'background-image': _vm.url ? 'url(' + _vm.url + ')' : null})},[(!_vm.url && _vm.initials.length)?_c('div',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }